module.exports = __webpack_public_path__ + "img/PL08517.b50c188a.png";